import { Injectable } from '@angular/core';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PrintService {
  isPrinting = false;

  constructor(private router: Router) { }

  // Open the unified print transaction document route used by the form's Print button
  // Include both subLedger and type query params to match how other navigation passes context
  printDocument(componentName: string, documentId: string, companyId: string, subLedger: string) {
    // console.log('print service called with these params: ' + componentName + ' : ' + documentId + ' : ' + companyId + ' : ' + subLedger);
    this.isPrinting = true;

    const link =
      this.router.serializeUrl(this.router.createUrlTree(['/transactions/' + componentName], {
        queryParams: {
          documentId,
          companyId,
          subLedger,
          type: subLedger
        }
      }));
    window.open(link, '_blank');

  }

}


